import { Dialog } from '@headlessui/react'
import { ModalStore } from '../../state/ModalStore'
import BrandMark from '../HomePageV2/BrandMark'

function InveloTransitionModal({ inveloUrl, onboardingUrl, olmUrl }) {
    const skimModal = ModalStore((state) => state.skim)
    const benefits = [
        {
            icon: '👥',
            iconBg: 'bg-[#f8f6ff]',
            title: 'Build your mailing list',
            body: 'Get help identifying and pulling the right audience.',
        },
        {
            icon: '🎯',
            iconBg: 'bg-[#fff0f0]',
            title: 'Set up your campaign',
            body: 'Work one-on-one with a specialist to build your campaign.',
        },
        {
            icon: '✉️',
            iconBg: 'bg-[#fff5e7]',
            title: 'Launch with confidence',
            body: 'Get help with targeting, timing, and campaign setup.',
            hideOnMobile: true,
        },
        {
            icon: '🎧',
            iconBg: 'bg-[#f1eaff]',
            title: 'Ongoing support',
            body: 'Have someone there to answer questions as you get started.',
            hideOnMobile: true,
        },
    ]

    const handleClick = () => {
        skimModal()
    }

    return (
        <Dialog
            as="div"
            className="fixed inset-0 z-[60] overflow-y-auto"
            open={true}
            onClose={skimModal}>
            <div className="flex min-h-screen items-center justify-center px-4 py-6 text-center sm:py-10">
                <div className="fixed inset-0 bg-black/25 backdrop-blur-[2px]" />
                <div className="fixed inset-0 bg-black/25" />
                <div className="relative z-10 w-[min(94vw,720px)] sm:w-[min(96vw,860px)] max-h-[96vh] overflow-y-auto rounded-[24px] bg-[#FFF6EE] text-left shadow-[0_18px_40px_rgba(0,0,0,0.22),0_2px_10px_rgba(0,0,0,0.08)] transition-all">
                    <div className="relative overflow-hidden bg-[#f7f7f8] px-3 py-3 sm:px-4 sm:py-4">
                        <div className="absolute left-[-48px] top-[12%] h-[110px] w-[110px] rounded-full bg-[radial-gradient(circle,rgba(245,130,42,0.12)_0%,transparent_68%)]" />
                        <div className="absolute bottom-[-50px] right-[-10px] h-[140px] w-[140px] rounded-full bg-[radial-gradient(circle,rgba(100,37,234,0.08)_0%,transparent_68%)]" />
                        <div className="relative rounded-[22px] bg-white px-4 py-5 sm:px-6 sm:py-6">
                            <div className="mx-auto flex max-w-3xl flex-wrap items-center justify-center gap-3 sm:gap-5">
                                <BrandMark compact />

                                <div className="text-[22px] font-medium text-[#74788e] sm:text-[28px]">
                                    x
                                </div>

                                <div className="text-[34px] font-extrabold leading-none tracking-[-1.5px] text-[#5f22e8] sm:text-[44px]">
                                    invelo
                                    <span className="text-[#d85784]">.</span>
                                </div>
                            </div>

                            <div className="mx-auto mt-4 w-fit rounded-full bg-[linear-gradient(90deg,#f1ecff,#f7f0ff)] px-4 py-2 text-[12px] font-extrabold text-[#5924d9] sm:text-[13px]">
                                ✓ One-on-one campaign support
                            </div>

                            <div className="mx-auto mt-4 max-w-3xl text-center">
                                <h2 className="text-[24px] font-extrabold leading-[1.06] tracking-[-1.2px] text-[#131a56] sm:text-[32px]">
                                    Get your campaign off to{' '}
                                    <span className="bg-[linear-gradient(90deg,#6023ec,#8e2fdc_55%,#ef4e60)] bg-clip-text text-transparent">
                                        the right start.
                                    </span>
                                </h2>
                                <p className="mx-auto mt-2.5 max-w-2xl text-[13px] leading-[1.5] text-[#5f6680] sm:text-[15px]">
                                    You&apos;ll be connected with Invelo for
                                    personalized onboarding and expert support
                                    to build a successful direct mail campaign.
                                </p>
                            </div>

                            <section className="mx-auto mt-4 grid max-w-4xl grid-cols-1 overflow-hidden rounded-[18px] border border-[#e9e4ff] bg-white shadow-[0_6px_24px_rgba(89,36,217,0.04)] sm:grid-cols-2 md:grid-cols-4">
                                {benefits.map((benefit, index) => (
                                    <article
                                        key={benefit.title}
                                        className={`px-3 py-4 text-center ${
                                            benefit.hideOnMobile
                                                ? 'hidden sm:block'
                                                : ''
                                        } ${
                                            index === 0
                                                ? 'border-b border-[#ece8f8]'
                                                : ''
                                        } ${
                                            index % 2 === 0 ? 'sm:border-r' : ''
                                        } ${
                                            index >= 2
                                                ? 'sm:border-b-0'
                                                : 'sm:border-b'
                                        } ${
                                            index < 3
                                                ? 'md:border-b-0 md:border-r'
                                                : ''
                                        }`}>
                                        <div
                                            className={`mx-auto mb-2.5 grid h-10 w-10 place-items-center rounded-full text-[20px] ${benefit.iconBg}`}>
                                            <span aria-hidden="true">
                                                {benefit.icon}
                                            </span>
                                        </div>
                                        <h3 className="text-[15px] font-bold leading-[1.15] text-[#131a56]">
                                            {benefit.title}
                                        </h3>
                                        <p className="mt-1.5 text-[12px] leading-[1.4] text-[#5f6680]">
                                            {benefit.body}
                                        </p>
                                    </article>
                                ))}
                            </section>

                            <div className="mx-auto mt-4 max-w-4xl">
                                <a
                                    href={onboardingUrl || inveloUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    onClick={handleClick}
                                    className="block w-full rounded-full bg-[linear-gradient(90deg,#ff4d45,#c13ab9_52%,#5f22e8)] px-5 py-3 text-center text-white shadow-[0_14px_34px_rgba(95,34,232,0.18)] transition hover:-translate-y-0.5 hover:shadow-[0_18px_42px_rgba(95,34,232,0.24)]">
                                    <strong className="block text-[16px] font-extrabold sm:text-[18px]">
                                        Schedule a Demo with Invelo
                                    </strong>
                                    <span className="mt-1 block text-[12px] opacity-95 sm:text-[13px]">
                                        You&apos;ll continue with our partner
                                        Invelo for your onboarding.
                                    </span>
                                </a>

                                <div className="my-3 flex items-center gap-4 text-center text-[12px] font-bold text-[#8a8da0] sm:text-[13px]">
                                    <div className="h-px flex-1 bg-[#e8e6ef]" />
                                    <span>OR</span>
                                    <div className="h-px flex-1 bg-[#e8e6ef]" />
                                </div>

                                <a
                                    href={olmUrl}
                                    onClick={handleClick}
                                    className="block rounded-[16px] border-2 border-[#bda8ff] bg-white px-5 py-3 text-center text-[#5d24db] transition hover:-translate-y-0.5 hover:bg-[#faf8ff]">
                                    <strong className="block text-[15px] font-bold sm:text-[17px]">
                                        I do not need assistance. I&apos;m ready
                                        to place my order!
                                    </strong>
                                    <span className="mt-1 block text-[12px] text-[#666c82] sm:text-[13px]">
                                        Continue directly to Open Letter
                                        Connect.
                                    </span>
                                </a>
                            </div>

                            <div className="mx-auto mt-4 max-w-4xl rounded-xl bg-[#f4f1ff] px-4 py-2.5 text-center text-[12px] text-[#62667a] sm:text-[13px]">
                                <b className="mr-2 text-[#5d24db]">
                                    ✓ Same commitment to quality.
                                </b>
                                Trusted production and mailing by Open Letter
                                Marketing.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default InveloTransitionModal
